<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8">
          <base-material-card>
            <template #heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <v-row>
                <v-col>
                  <va-field source="id"></va-field>
                  <v-row>
                    <v-col><va-field source="state" label="State" type="chip" color="orange"></va-field></v-col>
                    <v-col>
                      <va-field source="file.file_name" label="File Name" color="orange"></va-field>
                    </v-col>
                    <v-col>
                      <va-field source="file.extension" label="File Type" color="orange"></va-field>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col>
                  <template v-if="item">
                    <va-field source="createdAt" type="date" class="mt-0 pt-0">
                      {{ new Date(item.createdAt).toLocaleDateString('en-CA') }}
                    </va-field>
                    <va-field source="lastUpdatedAt" type="date">
                      {{ new Date(item.lastUpdatedAt).toLocaleDateString('en-CA') }}
                    </va-field>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
          <base-material-card v-if="item.file" title="Image">
            <template #heading>
              <div class="display-2">Image</div>
            </template>
            <v-card-text>
              <v-row>
                <v-col>
                  <resource-image :resource-id="item.id" :alt="item.file.file_name" big-picture />
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
import ResourceImage from '@/components/base/ResourceImage.vue';
import downloadMedia from '@/mixins/downloadMedia';

export default {
  components: {
    ResourceImage,
  },
  mixins: [downloadMedia],
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
};
</script>
